import { Theme } from "@mui/material";
import { SxProps } from "@mui/system";

const localeContainer: SxProps<Theme> = {
  display: "flex",
  flex: "0 0",
  width: "100vw",
  height: "100vh",
  overflow: "hidden",
};

export { localeContainer };
